// combine the reducers and export them
import { combineReducers } from 'redux';
import users from './users';
import authedUser from './authedUser';
import currentTab from './currentTab';
import { loadingBarReducer } from 'react-redux-loading';

export default combineReducers({
  users,
  authedUser,
  currentTab,
  loadingBar: loadingBarReducer,
});
